enum ToastSubType {
  AVAILABILITIES_TIMEOUT = 'AVAILABILITIES_TIMEOUT',
  AVAILABILITY_CONSTRAINT_CREATE_TIMEOUT = 'AVAILABILITY_CONSTRAINT_CREATE_TIMEOUT',
  AVAILABILITY_CONSTRAINT_DELETE_TIMEOUT = 'AVAILABILITY_CONSTRAINT_DELETE_TIMEOUT',
  AVAILABILITY_CONSTRAINT_GET_TIMEOUT = 'AVAILABILITY_CONSTRAINT_GET_TIMEOUT',
  AVAILABILITY_CONSTRAINT_HISTORIES_GET_TIMEOUT = 'AVAILABILITY_CONSTRAINT_HISTORIES_GET_TIMEOUT',
  AVAILABILITY_CONSTRAINT_UPDATE_TIMEOUT = 'AVAILABILITY_CONSTRAINT_UPDATE_TIMEOUT',
  CANCELLATION_FAILURE = 'CANCELLATION_FAILURE',
  CANCELLATION_TIMEOUT = 'CANCELLATION_TIMEOUT',
  CONVERT_RESERVATION_TAKING_LONGER_THAN_EXPECTED = 'CONVERT_RESERVATION_TAKING_LONGER_THAN_EXPECTED',
  CREATION_TIMEOUT = 'CREATION_TIMEOUT',
  NO_AVAILABILITIES_FOUND_WITHIN_RANGE = 'NO_AVAILABILITIES_FOUND_WITHIN_RANGE',
  NO_AVAILABLE_APPOINTMENT_TYPES_FOUND = 'NO_AVAILABLE_APPOINTMENT_TYPES_FOUND',
  RESCHEDULE_FAILURE = 'RESCHEDULE_FAILURE',
  RESCHEDULE_TIMEOUT = 'RESCHEDULE_TIMEOUT',
  START_DATE_IN_THE_PAST = 'START_DATE_IN_THE_PAST',
  START_DATE_NO_LONGER_AVAILABLE = 'START_DATE_NO_LONGER_AVAILABLE',
  SUCCESS = 'SUCCESS',
  UNAVAILABILITIES_NOT_SUPPORTED = 'UNAVAILABILITIES_NOT_SUPPORTED',
  UNAVAILABILITIES_TIMEOUT = 'UNAVAILABILITIES_TIMEOUT',
  UNHANDLED_ERROR = 'UNHANDLED_ERROR',
}

export { ToastSubType }
